import { string, number } from 'prop-types';
import { omit } from 'lodash';

export const CertifiedBannerDataPropTypes = {
    id: string.isRequired,
    description: string.isRequired,
    cta: string.isRequired,
    subCategoryId: number.isRequired,
    promoImageUrl: string.isRequired,
    logoUrl: string.isRequired,
    name: string.isRequired,
};

export const CertifiedBannerPropTypes = {
    ...omit(CertifiedBannerDataPropTypes, 'name', 'id'),
    tagName: string.isRequired,
    testId: string,
};
